/* eslint-disable */
import $ from './jquery'

function defineValue(obj, property, value) {
  if (Object.defineProperty) {
    try {
      Object.defineProperty(obj, property, {
        writable: true,
        value: value,
      });
    } catch (err) {
      obj[property] = value;
    }
  } else {
    obj[property] = value;
  }
}

/** HTMLCanvasElement API Polyfill **/
if (window.HTMLCanvasElement && !HTMLCanvasElement.prototype.toBlob) {
  defineValue(
    HTMLCanvasElement.prototype,
    "toBlob",
    function (callback, type, quality) {
      var binStr = atob(this.toDataURL(type, quality).split(",")[1]);
      var len = binStr.length;
      var arr = new Uint8Array(len);

      for (var i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      callback(new Blob([arr], { type: type || "image/png" }));
    }
  );
}

/** Extend String & Array **/
defineValue(String.prototype, "format", function (json, forceReplace) {
  var o;

  if (json instanceof Object) {
    o = json;
  } else {
    o = Array.from(arguments);

    if (typeof o[o.length - 1] === "boolean") {
      forceReplace = o.pop();
    }
  }

  var placeIndex = 0;

  return this.replace(/\{(\w+)\}(?!\})/g, function (m0, m1) {
    var v = o[m1];

    if (v === undefined || v === null) {
      v = forceReplace ? "" : m0;
    }

    return String(v);
  }).replace(/(%s)/g, function (m0, m1) {
    var v = o[placeIndex++];

    if (v === undefined || v === null) {
      v = forceReplace ? "" : m0;
    }

    return String(v);
  });
});

//replace $0 to matches[0], $1 to matches[1]
function _replaceMatches(str, matches) {
  return str.replace(/\$([$&\d])/g, function (m0, m1) {
    if (m1 === "$") {
      return "$";
    } else if (m1 === "&") {
      return matches[0];
    } else if (typeof matches[m1] === "string") {
      return matches[m1];
    } else {
      return m0;
    }
  });
}

//select matches and then replace or get submatches
defineValue(String.prototype, "select", function (re, tar) {
  var str = this;

  if (re.global) {
    var matches = [];

    str.replace(re, function () {
      var m = Array.from(arguments).slice(0, -2);

      if (typeof tar === "string") {
        matches.push(_replaceMatches(tar, m));
      } else if (typeof tar === "number") {
        matches.push(m[tar] || "");
      } else {
        matches.push(m[0]);
      }
    });

    return matches;
  } else {
    var m = str.match(re);

    if (m) {
      if (typeof tar === "string") {
        return _replaceMatches(tar, m);
      } else if (typeof tar === "number") {
        return m[tar] || "";
      } else {
        return m[0];
      }
    } else {
      return "";
    }
  }
});

//got every matches, then slice
defineValue(String.prototype, "matches", function (re, sliceStart) {
  var str = this;
  var matches = [];

  if (re.global) {
    str.replace(re, function () {
      var m = Array.from(arguments).slice(0, -2);

      if (sliceStart > 0) {
        m = m.slice(sliceStart);
      }

      matches.push(m);
    });

    return matches;
  } else {
    var m = Array.from(str.match(re));

    if (m) {
      if (sliceStart > 0) {
        m = m.slice(sliceStart);
      }

      return m;
    } else {
      return [];
    }
  }
});

defineValue(Array.prototype, "add", function (el) {
  var index = this.indexOf(el);
  if (index === -1) {
    this.push(el);
  }
});

defineValue(Array.prototype, "remove", function (el) {
  var index = this.indexOf(el);
  if (index > -1) {
    this.splice(index, 1);
  }
});

defineValue(Array.prototype, "index", function (fn) {
  var obj = {};

  if (fn) {
    for (var i = 0; i < this.length; i++) {
      var v = fn(this[i]);
      var key = v[0];
      var value = v[1];

      obj[key] = value;
    }
  } else {
    for (var i = 0; i < this.length; i++) {
      var value = this[i];
      obj[value] = true;
    }
  }

  return obj;
});

defineValue(Number.prototype, "toMaxFixed", function (decimal) {
  var rate = Math.pow(10, decimal);
  return Math.round(this * rate) / rate;
});

/** Overwrite jQuery fn **/
var oldShow = $.fn.show;

$.fn.show = function () {
  this.css("display", "");
  this.removeAttr("hidden");

  if (this.css("display") === "none") {
    oldShow.apply(this, arguments);
  }

  return this;
};

$.fn.hide = function () {
  this.attr("hidden", "hidden");
  return this;
};

//Extend jQuery Event to support scope
var _oldOn = $.fn.on;
var _oldOff = $.fn.off;

var _bindEvent = function (isOnce, eventName, handler, scope) {
  //由于无法使用 jQuery 注册 wheel 等事件, 会没有 delta 系列参数, 所以现在优先使用源生事件
  var useJqueryEvent =
    !isOnce && arguments.length >= 4 && typeof handler !== "function";
  if (useJqueryEvent) {
    var args = Array.from(arguments).slice(1);
    return _oldOn.apply(this, args);
  }

  if (typeof handler !== "function") {
    console.warn('The "handler" must be specified!');
  }

  if (eventName.includes(" ")) {
    var eventNames = eventName.split(" ");
    for (var i = 0; i < eventNames.length; i++) {
      this.on(eventNames[i], handler, scope);
    }
    return this;
  }

  this.each(function (index, el) {
    if (!el._events) {
      el._events = {};
    }

    if (!el._events[eventName]) {
      el._events[eventName] = [];
    }

    var bindedHandler;

    if (isOnce) {
      bindedHandler = function (event) {
        $(el).off(eventName, handler, scope);

        if (event && event.originalEvent) {
          for (var i in event.originalEvent) {
            if (typeof event[i] === "undefined") {
              event[i] = event.originalEvent[i];
            }
          }
        }

        $.digestAwait(handler.call(scope || this, event));
      };
    } else {
      bindedHandler = function (event) {
        if (event && event.originalEvent) {
          for (var i in event.originalEvent) {
            if (typeof event[i] === "undefined") {
              event[i] = event.originalEvent[i];
            }
          }
        }

        $.digestAwait(handler.call(scope || this, event));
      };
    }

    el._events[eventName].push({
      name: eventName,
      handler: handler.__original || handler, //here to make it can unbind blockFn, throttoe, debounce
      scope: scope,
      bindedHandler: bindedHandler,
    });

    _oldOn.call($(el), eventName, bindedHandler);
  });

  return this;
};

$.fn.on = function () {
  var args = Array.from(arguments);
  args.unshift(false);

  return _bindEvent.apply(this, args);
};

$.fn.once = function () {
  var args = Array.from(arguments);
  args.unshift(true);

  return _bindEvent.apply(this, args);
};

$.fn.off = function (eventName, handler, scope) {
  this.each(function (index, el) {
    if (!el._events) {
      return;
    }

    var events = el._events[eventName];

    if (events) {
      for (var i = events.length - 1; i >= 0; i--) {
        var event = events[i];
        if (
          event.handler === handler &&
          (event.scope === scope || (!event.scope && !scope))
        ) {
          events.splice(i, 1);

          $(el).off(event.name, event.bindedHandler);
        }
      }
    }
  });

  return _oldOff.apply(this, arguments);
};

/** Extend jQuery fn, Selector & DOM Constructor & Properties **/
$.fn.indexOf = function (el) {
  el = $(el);

  for (var i = 0; i < this.length; i++) {
    if (this[i] === el[0]) {
      return i;
    }
  }

  return -1;
};

$.fn.cssNum = function (property) {
  var val = this.css(property);
  return parseFloat(val) || 0;
};

$.fn.findNearestBehind = function (selector) {
  var els = $(selector);

  if (!els.length) {
    return els;
  }

  for (var i = 0; i < els.length; i++) {
    if (els[i].compareDocumentPosition(this[0]) & 2) {
      return els.eq(i);
    }
  }

  return els.eq(els.length - 1);
};

$.fn.formObj = function (overwrite) {
  var data = {};

  this.find("input, textarea").each(function (index, input) {
    if (input.name) {
      if (input.type === "radio") {
        if (input.checked) {
          data[input.name] = String(input.value).trim();
        }
      } else {
        data[input.name] = String(input.value).trim();
      }
    }
  });

  if (overwrite) {
    $.extend(data, overwrite);
  }

  return data;
};

$.fn.formData = function (overwrite) {
  var formData = new FormData();

  this.find("input, textarea").each(function (index, input) {
    var nameInoverwrite = overwrite && input.name in overwrite;
    if (input.name && !nameInoverwrite) {
      if (input.type === "radio") {
        if (input.checked) {
          formData.append(input.name, String(input.value).trim());
        }
      } else {
        formData.append(input.name, String(input.value).trim());
      }
    }
  });

  if (overwrite) {
    for (var name in overwrite) {
      if (overwrite[name] !== false) {
        formData.append(name, String(overwrite[name]).trim());
      }
    }
  }

  return formData;
};

$.fn.checkValidity = function () {
  var inputs = this.find("input, textarea");
  var invalidInputs = this.find("input:invalid, textarea:invalid");

  inputs.addClass("touched");

  if (invalidInputs.length) {
    for (var i = 0; i < invalidInputs.length; i++) {
      var invalidInput = invalidInputs[i];
      if ($(invalidInput).is(":visible")) {
        invalidInput.checkValidity();
        return false;
      }
    }
  }

  return true;
};

/** Extend jQuery fn, Layout **/
$.fn.outerWidth = function () {
  if (!this[0]) {
    return 0;
  }

  var ml = parseInt(this.css("margin-left")) || 0;
  var mr = parseInt(this.css("margin-right")) || 0;

  return this[0].offsetWidth + ml + mr;
};

$.fn.outerHeight = function () {
  if (!this[0]) {
    return 0;
  }

  var mt = parseInt(this.css("margin-top")) || 0;
  var mb = parseInt(this.css("margin-bottom")) || 0;

  return this[0].offsetHeight + mt + mb;
};

$.fn.innerWidth = function () {
  if (!this[0]) {
    return 0;
  }

  var pl = parseInt(this.css("padding-left")) || 0;
  var pr = parseInt(this.css("padding-right")) || 0;

  return this[0].clientWidth - pl - pr;
};

$.fn.innerHeight = function () {
  if (!this[0]) {
    return 0;
  }

  var pt = parseInt(this.css("padding-top")) || 0;
  var pb = parseInt(this.css("padding-bottom")) || 0;

  return this[0].clientHeight - pt - pb;
};

//pos support tc, bc, tl, bl, tr, br
$.fn.alignTo = function (el, pos, gap, canOverflowY) {
  el = $(el);

  if (el.hasFixedAncestor()) {
    this.css("position", "fixed");
  }

  if (!pos) {
    pos = "bc";
  } else if (pos.length === 1) {
    pos += "c";
  }

  if (typeof gap === "boolean") {
    canOverflowY = gap;
    gap = null;
  }

  if (typeof gap === "string") {
    gap = gap.split(" ").map(Number);
  } else if (typeof gap === "number") {
    gap = [gap];
  } else {
    gap = gap || [];
  }

  gap[0] = gap[0] || 0;
  gap[1] = (gap[1] === undefined ? gap[0] : gap[1]) || 0;

  //如果支持滚动, 设置高度为 0, 防止造成意外的窗口滚动条弹出
  if (canOverflowY) {
    this.height(0);
  }

  var isFixed = this.css("position") === "fixed";
  var isElBodyOrHTML = el.is("html, body");
  var box = $.extend({}, el[0].getBoundingClientRect()); //Object.assign not work here, since the returned object has no own properties
  box.width = box.width || box.right - box.left;
  box.height = box.height || box.bottom - box.top;

  //如果 el 是 html 或者 body, 将 box 设置为可视区, 而不是滚动区
  if (isElBodyOrHTML && isFixed) {
    box.width = document.documentElement.clientWidth;
    box.height = document.documentElement.clientHeight;
    box.top = 0;
    box.bottom = box.height;
  }

  //如果支持滚动, 还原原始高度
  if (canOverflowY) {
    this.height("auto");
  }

  //trangle
  var isVertical = pos.startsWith("t") || pos.startsWith("b");
  var trangleEl = this.find("[class*=trangle]");
  trangleEl
    .removeClass("ap-align-top")
    .removeClass("ap-align-bottom")
    .removeClass("ap-align-left")
    .removeClass("ap-align-right");
  if (trangleEl.length) {
    if (isVertical) {
      trangleEl.addClass("ap-align-top");
      gap[1] += trangleEl[0].offsetHeight;
      trangleEl.removeClass("ap-align-top");
    } else {
      trangleEl.addClass("ap-align-left");
      gap[0] += trangleEl[0].offsetWidth;
      trangleEl.removeClass("ap-align-left");
    }
  }

  box.width += gap[0] * 2;
  box.height += gap[1] * 2;
  box.left -= gap[0];
  box.top -= gap[1];
  box.right += gap[0];
  box.bottom += gap[1];

  var dw = $(window).width(),
    dh = $(window).height();

  var w = this[0].offsetWidth,
    h = this[0].offsetHeight;

  //x
  var x = 0;
  var y = 0;

  if (pos === "cc") {
    x = box.left + box.width / 2 - w / 2;
    y = box.top + box.height / 2 - h / 2;
  } else if (isVertical) {
    var alignBottom = pos.startsWith("b"),
      alignTop = pos.startsWith("t"),
      spaceTop = box.top,
      spaceBottom = dh - box.bottom;

    //y
    y = alignTop ? box.top - h : box.top + box.height;

    //fix y
    if (alignTop && y < 0 && spaceTop < spaceBottom) {
      y = box.bottom;
      alignTop = false;
      alignBottom = true;
    } else if (y + h > dh && spaceTop > spaceBottom) {
      y = box.top - h;
      alignTop = true;
      alignBottom = false;
    }

    trangleEl.addClass(alignTop ? "ap-align-top" : "ap-align-bottom");

    if (canOverflowY) {
      if (y < 0) {
        y = 0;
        this[0].style.height = spaceTop + "px";
      } else if (y + h > dh) {
        this[0].style.height = spaceBottom + "px";
      }

      w = this[0].offsetWidth;
    }

    //x
    if (pos.includes("c")) {
      x = box.left + box.width / 2 - w / 2;
    } else if (pos.includes("l")) {
      x = box.left;
    } else if (pos.includes("r")) {
      x = box.left + box.width - w;
    }

    if (x + w > dw) {
      x = dw - w;
    } else if (x < 0) {
      x = 0;
    }

    if (trangleEl.length) {
      if (w >= box.width) {
        var trangleLeft =
          box.left + box.width / 2 - x - trangleEl[0].offsetWidth / 2;
      } else {
        var trangleLeft = w / 2 - trangleEl[0].offsetWidth / 2;
      }

      trangleEl.css("left", trangleLeft);
    }
  } else {
    var alignLeft = pos.startsWith("l"),
      alignRight = pos.startsWith("r"),
      spaceLeft = box.left,
      spaceRight = dw - box.right;

    if (pos.includes("c")) {
      y = box.top + box.height / 2 - h / 2;
    } else if (pos.includes("l")) {
      y = box.top;
    } else if (pos.includes("r")) {
      y = box.top + box.height - h;
    }

    if (y + h > dh) {
      y = dh - h;
    } else if (y < 0) {
      y = 0;
    }

    //x
    x = alignLeft ? box.left - w : box.left + box.width;

    //fix x
    if (alignLeft && x < 0 && spaceLeft < spaceRight) {
      x = box.right;
      alignLeft = false;
      alignRight = true;
    } else if (x + w > dw && spaceLeft > spaceRight) {
      x = box.left - w;
      alignLeft = true;
      alignRight = false;
    }

    trangleEl.addClass(alignLeft ? "ap-align-left" : "ap-align-right");

    if (trangleEl.length) {
      if (pos.endsWith("b")) {
        var trangleTop =
          box.top + box.height / 2 - y - trangleEl[0].offsetHeight / 2;
      } else if (pos.endsWith("t")) {
        var trangleTop = trangleEl[0].offsetHeight;
      } else {
        var trangleTop = h / 2 - trangleEl[0].offsetHeight / 2;
      }

      trangleEl.css("top", trangleTop);
    }
  }

  //如果元素不是 fixed, 将坐标处理为相对坐标
  if (!isFixed) {
    var offsetParent = this[0].offsetParent;
    if (offsetParent) {
      var parentBox = $.extend({}, offsetParent.getBoundingClientRect());
      parentBox.width = parentBox.width || parentBox.right - parentBox.left;
      parentBox.height = parentBox.height || parentBox.bottom - parentBox.top;
      x -= parentBox.left + $(offsetParent).cssNum("border-left-width");
      y -= parentBox.top + $(offsetParent).cssNum("border-top-width");

      if (pos.endsWith("t")) {
        y = -trangleEl[0].offsetHeight / 2;
      }
    }
  }

  this.css({ left: parseInt(x), top: parseInt(y) });
};

$.fn.hasFixedAncestor = function () {
  var el = this;
  var position = el.css("position");

  while (
    el &&
    el.length &&
    el[0] !== document.documentElement &&
    position !== "fixed"
    ) {
    el = el.parent();
    position = el.css("position");
  }

  return position === "fixed";
};

$.fn.scrollToView = function (gapY, duration) {
  gapY = gapY || 0;
  duration = duration || 500;

  var el = this[0];
  var newY;

  if (!el) {
    return;
  }

  //find the element which children overflow from it
  var scroller = el.parentNode;
  while (
    scroller &&
    scroller !== document &&
    (["visible", "hidden"].includes($(scroller).css("overflow-y")) ||
      scroller.scrollHeight <= scroller.clientHeight)
    ) {
    scroller = scroller.parentNode;
  }

  if (scroller === document) {
    return;
  }

  var y = el.offsetTop,
    offsetEl = el,
    scrollY = scroller.scrollTop;

  while (offsetEl.offsetParent && offsetEl.offsetParent !== scroller) {
    y += offsetEl.offsetParent.offsetTop;
    offsetEl = offsetEl.offsetParent;
  }

  //make sure y - gapY > scrollY and y + h + gapY < scrollY + pH
  if (y - gapY < scrollY) {
    newY = Math.max(0, y - gapY);
  } else if (y + el.offsetHeight + gapY > scrollY + scroller.clientHeight) {
    newY = Math.min(
      scroller.scrollHeight,
      y + el.offsetHeight + gapY - scroller.clientHeight
    );
  }

  if (newY === scrollY) {
    newY = undefined;
  }

  if (newY >= 0) {
    if (scroller === document.documentElement || scroller === document.body) {
      $("html, body").animate(
        {
          scrollTop: newY,
        },
        duration
      );
    } else {
      $(scroller).animate(
        {
          scrollTop: newY,
        },
        duration
      );
    }
  }
};

$.fn.scrollToTop = function (gapY, duration) {
  gapY = gapY || 0;
  duration = duration || 500;

  var el = this[0];
  var newY;

  if (!el) {
    return;
  }

  //find the element which children overflow from it
  var scroller = el.parentNode;
  while (
    scroller &&
    scroller !== document &&
    (["visible", "hidden"].includes($(scroller).css("overflow-y")) ||
      scroller.scrollHeight <= scroller.clientHeight)
    ) {
    scroller = scroller.parentNode;
  }

  if (scroller === document) {
    return;
  }

  var y = el.offsetTop,
    offsetEl = el,
    scrollY = scroller.scrollTop;

  while (offsetEl.offsetParent && offsetEl.offsetParent !== scroller) {
    y += offsetEl.offsetParent.offsetTop;
    offsetEl = offsetEl.offsetParent;
  }

  newY = Math.max(0, y - gapY);

  if (scroller === document.documentElement || scroller === document.body) {
    $("html, body").animate(
      {
        scrollTop: newY,
      },
      duration
    );
  } else {
    $(scroller).animate(
      {
        scrollTop: newY,
      },
      duration
    );
  }
};

//make sure mouse wheel not broadcast to affect outer elements
//its a replacement for scroll-behavior: contain
$.fn.stopScroll = function () {
  this.each(function (index, el) {
    $(el).on(
      "wheel",
      (el._scrollWheelHandler = function (e) {
        var scrollTop = el.scrollTop;

        if (e.deltaY < 0) {
          if (scrollTop <= 0 && el.scrollHeight > el.clientHeight) {
            e.preventDefault();
          }
        } else {
          if (
            scrollTop >= el.scrollHeight - el.offsetHeight &&
            el.scrollHeight > el.clientHeight
          ) {
            e.preventDefault();
          }
        }
      }),
      this
    );

    if ($.env.isTouch) {
      var startY;
      $(el).on(
        "touchstart",
        (el._scrollTouchStartHandler = function (e) {
          e.stopPropagation();

          startY = e.touches[0].pageY;
        })
      );

      $(el).on(
        "touchmove",
        (el._scrollTouchMoveHandler = function (e) {
          e.stopPropagation();

          var scrollTop = el.scrollTop;
          var newPageY = e.touches[0].pageY;

          if (newPageY > startY) {
            if (scrollTop <= 0 && el.scrollHeight > el.clientHeight) {
              e.preventDefault();
            }
          } else if (newPageY < startY) {
            if (
              scrollTop >= el.scrollHeight - el.offsetHeight &&
              el.scrollHeight > el.clientHeight
            ) {
              e.preventDefault();
            }
          }
        })
      );
    }
  });
};

$.fn.restoreScroll = function () {
  this.each(function (index, el) {
    if (el._scrollWheelHandler) {
      $(el).off("wheel", el._scrollWheelHandler);
      delete el._scrollWheelHandler;
    }

    if (el._scrollTouchStartHandler) {
      $(el).off("touchstart", el._scrollTouchStartHandler);
      delete el._scrollTouchStartHandler;
    }

    if (el._scrollTouchMoveHandler) {
      $(el).off("touchmove", el._scrollTouchMoveHandler);
      delete el._scrollTouchMoveHandler;
    }
  });
};

/** Extend jQuery fn, Events **/
$.fn.onPan = function (fn, scope) {
  this.each(function (index, el) {
    var $el = $(el);

    el.addEventListener(
      "touchstart",
      function (e) {
        $el.css("transition", "none");

        var startX = e.changedTouches[0].pageX,
          startY = e.changedTouches[0].pageY;

        var originalTransform = originalTransform || $el.css("transform");
        var transformNums = originalTransform
          .select(/matrix\((.+?)\)/, "$1")
          .split(/,\s*/);
        var originalScaleNum = +transformNums[0] || 0;
        var originalTransformX = +transformNums[4] || 0;
        var originalScale = originalScaleNum
          ? " scale(" + originalScaleNum + ")"
          : "";

        function onTouchEnd(e) {
          $el.css("transition", "");

          if ($el.dir("fit")) {
            $el.css("transform", originalTransform);
          } else {
            $el.css("transform", "");
          }

          document.removeEventListener("touchmove", onTouchMove, false);
          document.removeEventListener("touchend", onTouchEnd, false);

          var x = e.changedTouches[0].pageX,
            y = e.changedTouches[0].pageY;

          var movedX = x - startX,
            movedY = y - startY;

          if (Math.abs(movedX / movedY) > 1 && Math.abs(movedX) > 20) {
            e.preventDefault();

            if (movedX > 0) {
              fn.call(scope, "l");
            } else {
              fn.call(scope, "r");
            }
          } else if (Math.abs(movedX / movedY) < 1 && Math.abs(movedY) > 20) {
            e.preventDefault();

            if (movedY > 0) {
              fn.call(scope, "b");
            } else {
              fn.call(scope, "t");
            }
          }
        }

        function onTouchMove(e) {
          var x = e.changedTouches[0].pageX,
            y = e.changedTouches[0].pageY;

          var movedX = x - startX,
            movedY = y - startY;

          if (Math.abs(movedX / movedY) > 1) {
            e.preventDefault();
            $el.css(
              "transform",
              "translateX(" +
              (movedX + originalTransformX) +
              "px)" +
              originalScale
            );
          }
        }

        document.addEventListener("touchmove", onTouchMove, false);
        document.addEventListener("touchend", onTouchEnd, false);
      },
      false
    );
  });
};

/** Extend jQuery fn, Text **/
$.fn.getTextWidth = function () {
  var testTextEl = $("#test-text-element");

  if (!testTextEl.length) {
    testTextEl = $(
      '<div id="test-text-element" style="position: fixed; left: 0; top: -100px;"></div>'
    ).appendTo("body");
  }

  testTextEl.css("font-size", this.css("font-size"));
  testTextEl.css("font-family", this.css("font-family"));
  testTextEl.css("font-weight", this.css("font-weight"));
  testTextEl.css("letter-spacing", this.css("letter-spacing"));
  testTextEl.text(this.text());
  testTextEl.show();

  var width = testTextEl.width();
  testTextEl.hide();

  return width;
};

//reset font-size to make text contained, used for white-space:nowrap elements
$.fn.resetFontSizeToBeContained = function (minSize) {
  this.each(function (index, el) {
    var $el = $(el);

    $el.css("font-size", "");
    $el.css("overflow-x", "hidden");

    var currWidth = $el.innerWidth();
    var textWidth =
      el.scrollWidth -
      $el.cssNum("padding-left") -
      $el.cssNum("padding-right");
    var fontSize = parseInt($el.css("font-size"));
    var resizeMaxTimes = 3;
    var resizeTimes = 0;

    while (
      textWidth > currWidth &&
      currWidth > 0 &&
      fontSize > 10 &&
      resizeTimes < resizeMaxTimes
      ) {
      resizeTimes++;

      var newFontSize = Math.floor((fontSize * currWidth) / textWidth);
      newFontSize = Math.max(newFontSize, minSize || 10);
      $el.css("font-size", newFontSize + "px");

      currWidth = $el.innerWidth();
      textWidth =
        el.scrollWidth -
        $el.cssNum("padding-left") -
        $el.cssNum("padding-right");
      fontSize = newFontSize;
    }

    $el.css("overflow-x", "");
  });
};

//reset font-size to make it in one line, use it to adjust elements which may have multiple lines, narrow elements should also set word-break: break-word
$.fn.resetFontSizeToBeLine = function (lineCount) {
  lineCount = lineCount || 1;

  this.each(function (index, el) {
    var $el = $(el);

    $el.css("font-size", "");

    var lineHeight = parseInt($el.css("line-height"));
    var height = el.scrollHeight || el.offsetHeight;

    if (height && Math.round(height / lineHeight) > lineCount) {
      var fontSize = parseInt($el.css("font-size"));

      while (fontSize >= 10) {
        fontSize--;
        $el.css("font-size", fontSize + "px");
        height = el.scrollHeight || el.offsetHeight;

        if (Math.round(height / lineHeight) <= lineCount) {
          break;
        }
      }
    }
  });
};

/** Extend jQuery, Miscellaneous **/
//set interval until fn returns true, then call callback
$.until = function (intervalTime, fn, callback, scope) {
  var id = setInterval(function () {
    var value = fn.call(scope);
    if (value) {
      clearInterval(id);
      callback.call(scope, value);
    }
  }, intervalTime);
};

//parse url params
$.parseQuery = function (url) {
  var paramsArray = url
    .select(/\?(.+)/, 1)
    .split("&")
    .filter(function (v) {
      return v;
    })
    .map(function (part) {
      var parts = part.split("=");
      parts[1] = decodeURIComponent(parts[1]);
      return parts;
    });

  var params = {};
  for (var i = 0; i < paramsArray.length; i++) {
    if (paramsArray[i][0] && paramsArray[i][1]) {
      params[paramsArray[i][0]] = paramsArray[i][1];
    }
  }

  return params;
};

//add url params
$.useQuery = function (url, params) {
  var hasQuery = url.includes("?");

  if (typeof params === "string") {
    return url + (hasQuery ? "&" : "?") + params;
  }

  for (var i in params) {
    var param = encodeURIComponent(params[i]);

    url += (hasQuery ? "&" : "?") + i + "=" + param;
    hasQuery = true;
  }

  return url;
};

$.encodeHTML = function (str) {
  var re = /&|>|<|"|'/g;
  var map = {
    "&": "&amp;",
    ">": "&gt;",
    "<": "&lt;",
    '"': "&quot;",
    "'": "&apos;",
  };

  return str.replace(re, function (m0) {
    return map[m0] || m0;
  });
};

//get a readable size string from byte count
$.formatSize = function (bytes) {
  if (!(bytes > 0)) {
    return "";
  }

  var units = ["B", "KB", "MB", "GB", "TB"],
    level = parseInt(Math.floor(Math.log(bytes) / Math.log(1024))),
    count = bytes / Math.pow(1024, level);

  if (count < 10) {
    count = count.toFixed(2);
  } else if (count < 100) {
    count = count.toFixed(1);
  } else {
    count = count.toFixed(0);
  }

  count = count.replace(/\.0+$/, "");

  return count + " " + units[level];
};

$.secondToDate = function (result) {
  var m =
    Math.floor((result / 60) % 60) < 10
      ? "0" + Math.floor((result / 60) % 60)
      : Math.floor((result / 60) % 60);
  var s =
    Math.floor(result % 60) < 10
      ? "0" + Math.floor(result % 60)
      : Math.floor(result % 60);
  return (result = m + ":" + s);
};

$.formatEnglishDate = function (millinSeconds) {
  var date = new Date(millinSeconds * 1000);
  var monthArr = new Array(
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Spt",
    "Oct",
    "Nov",
    "Dec"
  );
  var suffix = new Array("st", "nd", "rd", "");

  var year = date.getFullYear(); //年
  var month = monthArr[date.getMonth()]; //月
  var ddate = date.getDate(); //日

  if (ddate % 10 < 1 || ddate % 10 > 3) {
    ddate = ddate + suffix[3];
  } else if (ddate % 10 == 1) {
    ddate = ddate + suffix[0];
  } else if (ddate % 10 == 2) {
    ddate = ddate + suffix[1];
  } else {
    ddate = ddate + suffix[2];
  }
  return month + " " + ddate + "." + year;
};

$.formatDate = function (date, formatter) {
  formatter = formatter || "yyyy-MM-dd hh:mm:ss";

  var GET_METHODS = {
    y: "getFullYear",
    M: "getMonth",
    d: "getDate",
    h: "getHours",
    m: "getMinutes",
    s: "getSeconds",
  };

  return formatter.replace(/y+|M+|d+|h+|m+|s+/g, function (m0) {
    var method = GET_METHODS[m0[0]];
    var n = date[method]();

    if (m0[0] === "M") {
      n += 1;
    }

    return String(n).padStart(m0.length, "0");
  });
};

/** Extend jQuery, Layout **/
$.getScrollBarWidth = function (el) {
  var width;

  if ($(el).length) {
    width = $(el)[0].offsetWidth - $(el)[0].clientWidth;
  } else {
    var div = $(
      '<div style="width:100px; height:100px; overflow:scroll; position:absolute; left:-100px; top:-100px;"></div>'
    ).appendTo("body");
    width = div[0].offsetWidth - div[0].clientWidth;

    div.remove();
  }

  return width;
};

/** Extend jQuery, Event **/
  //when mouse leave all for 200ms, already known that mouse in first of els
var _bindAllLeave = function (isOnce, els, time, callback, scope) {
    var mouseIn = true;
    var timeout = 0;

    function enter() {
      mouseIn = true;
    }

    function leave() {
      mouseIn = false;

      timeout = setTimeout(function () {
        timeout = 0;
        if (!mouseIn) {
          if (isOnce) {
            unbind();
          }

          trigger();
        }
      }, time);
    }

    function trigger() {
      callback.call(scope);
    }

    function unbind() {
      if (timeout) {
        clearTimeout(timeout);
      }

      for (var i = 0; i < els.length; i++) {
        var el = $(els[i]);
        el.off("mouseenter", enter);
        el.off("mouseleave", leave);
      }
    }

    for (var i = 0; i < els.length; i++) {
      var el = $(els[i]);
      el.on("mouseenter", enter);
      el.on("mouseleave", leave);
    }

    return unbind;
  };

$.onAllLeave = function (els, time, callback, scope) {
  return _bindAllLeave(false, els, time, callback, scope);
};

//auto unbind after leave
$.onceAllLeave = function (els, time, callback, scope) {
  return _bindAllLeave(true, els, time, callback, scope);
};

/** Extend jQuery, Resources **/
$.selectFile = function (type, multiple, callback, scope) {
  if (!type) type = "*";
  if (!multiple) multiple = false;
  if (typeof multiple === "function") {
    scope = callback;
    callback = multiple;
    multiple = false;
  }

  return new Promise((resolve) => {
    var input = $(
      '<input type="file" accept="' +
      type +
      '" ' +
      (multiple ? "multiple" : "") +
      ' style="display: none">'
    );

    input.on("change", function (e) {
      let value = multiple ? e.target.files : e.target.files[0];

      if (callback) {
        callback.call(scope, value);
      }

      resolve(value);
    });

    $(document).once("focus", function () {
      input.remove();
    });

    $(document.body).append(input);

    input[0].click();
  });
};

$.selectMultipleFiles = function (type, callback, scope) {
  return $.selectFile(type, true, callback, scope);
};

$.preloadImage = function (url, callback, scope) {
  return new Promise((resolve, reject) => {
    var img = $('<img crossorigin="anonymous" src="' + url + '" hidden>');

    var handler = function (e) {
      img.off("load", handler);
      img.off("error", handler);

      var ok = e === true || (e && e.type === "load");

      img.remove();

      if (callback) {
        callback.call(scope, ok ? img[0] : null);
      }

      if (e.type === "load") {
        resolve(img);
      } else {
        reject();
      }
    };

    img.appendTo("body");

    if (img[0].naturalWidth && img[0].naturalHeight && img[0].complete) {
      handler(true);
    } else {
      img.on("load error", handler);
    }
  });
};

$.loadScript = function (url, callback, scope) {
  return new Promise((resolve, reject) => {
    var scriptEl = document.createElement("script");
    scriptEl.src = url;
    document.head.appendChild(scriptEl);

    $(scriptEl).on("load error", (e) => {
      if (callback) {
        callback.call(scope);
      }

      if (e.type === "load") {
        resolve();
      } else {
        reject();
      }
    });

    document.head.removeChild(scriptEl);
  });
};

$.loadSources = function (map, callback, scope) {
  return new Promise((resolve, reject) => {
    var asyncCount = 0;
    var asyncTotal = 0;

    if (typeof map === "string") {
      map = [map];
    }

    if (map instanceof Array) {
      var o = { css: [], js: [] };

      for (var i = 0; i < map.length; i++) {
        var ext = map[i].select(/\.(\w+)(?:$|\?)/, 1);
        if (ext === "css") {
          o.css.push(map[i]);
        } else {
          o.js.push(map[i]);
        }
      }

      map = o;
    }

    function onEachLoaded(e) {
      if (++asyncCount >= asyncTotal) {
        if (callback) {
          callback.call(scope);
        }

        if (e.type === "load") {
          resolve();
        } else {
          reject();
        }
      }
    }

    for (var i = 0; i < map.css.length; i++) {
      asyncTotal++;

      var cssPath = map.css[i];
      var linkEl = $('<link rel="stylesheet" href="{0}">'.format(cssPath));

      linkEl.appendTo("head").on("load", onEachLoaded);
    }

    for (var i = 0; i < map.js.length; i++) {
      asyncTotal++;

      var jsPath = map.js[i];
      var scriptEl = document.createElement("script");
      scriptEl.async = false;
      scriptEl.src = jsPath;
      document.head.appendChild(scriptEl);

      $(scriptEl).on("load error", onEachLoaded);
    }
  });
};

/** Extend jQuery, Time Related **/
($.defer = function (fn, ms, scope) {
  if (ms && typeof ms === "object") {
    scope = ms;
    ms = 0;
  } else {
    ms = ms || 0;
  }

  fn = scope ? fn.bind(scope) : fn;

  let ended = false;
  let timer = 0;

  function cancel() {
    if (timer) {
      clearTimeout(timer);
      timer = 0;
    }

    ended = true;
  }

  function onTimeout() {
    timer = 0;
    ended = true;
    fn();
  }

  timer = setTimeout(onTimeout, ms);

  return {
    cancel,
  };
}),
  //like throttle, nut not ensure last calling
  ($.throttle = function (fn, ms) {
    var timeout = 0;

    var wrap = function () {
      if (!timeout) {
        fn.apply(this, arguments);

        timeout = setTimeout(function () {
          timeout = 0;
        }, ms);
      }
    };

    wrap.__original = fn;

    return wrap;
  });

//like throttle, but not trigger the first calling
$.lazyThrottle = function (fn, ms) {
  var timeout = 0,
    args,
    scope;

  var newTimeout = function () {
    timeout = setTimeout(function () {
      timeout = 0;

      if (args) {
        fn.apply(scope, args);
        newTimeout();
        scope = null;
        args = null;
      }
    }, ms);
  };

  var wrap = function () {
    scope = this;
    args = Array.from(arguments);

    if (!timeout) {
      newTimeout();
    }
  };

  wrap.__original = fn;

  return wrap;
};

//used for input searching, not trigger when called frequently
$.debounce = function (fn, ms) {
  var timeout = 0;
  var curScope;
  var args;

  var wrap = function () {
    if (timeout) {
      clearTimeout(timeout);
    }

    args = Array.from(arguments);
    curScope = this;
    timeout = setTimeout(function (args) {
      timeout = 0;
      fn.apply(curScope, args);
    }, ms);
  };

  wrap.__original = fn;

  wrap.__cancel = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = 0;
    }
  };

  wrap.__flush = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = 0;
      fn.apply(curScope, args);
    }
  };

  return wrap;
};

/** Load & Ready Events **/
//jquery ready has bug with defered script, so we need this api
//you also need to know that async script doesn't defer DOMContentLoaded, so the DOMContentLoaded may never trigger for async script
$.onReady = function (fn, scope) {
  fn = fn.bind(scope, $);

  if ($._domLoaded) {
    fn();
  } else {
    $(document).once("DOMContentLoaded", fn);
  }
};
$(document).once("DOMContentLoaded", function () {
  $._domLoaded = true;
});

//window loaded to trigger
$.onWindowLoaded = function (fn, scope) {
  if ($._winLoaded) {
    fn.call(scope);
  } else {
    $(window).once("load", fn, scope);
  }
};
$(window).once("load", function () {
  $._winLoaded = true;
});

//a simple interface to access localStorage
$.store = {
  prefix: "",

  isSupported: function () {
    try {
      localStorage.__supports_test = 1;
      delete localStorage.__supports_test;
      return true;
    } catch (e) {
      return false;
    }
  },

  has: function (key) {
    try {
      return this.prefix + key in localStorage;
    } catch (e) {
      return false;
    }
  },

  get: function (key) {
    try {
      var v = localStorage[this.prefix + key];

      if (v && typeof v === "string") {
        v = JSON.parse(v);

        var expiredTime = localStorage[this.prefix + key + "_expire"];
        if (expiredTime && expiredTime < Date.now()) {
          delete localStorage[this.prefix + key];
          delete localStorage[this.prefix + key + "_expire"];
          return null;
        } else {
          return v;
        }
      }
    } catch (e) {}

    return null;
  },

  set: function (key, value, expire) {
    try {
      localStorage[this.prefix + key] = JSON.stringify(value);

      if (expire) {
        localStorage[this.prefix + key + "_expire"] = Date.now() + expire;
      }

      return true;
    } catch (err) {
      return false;
    }
  },

  remove: function (key) {
    try {
      delete localStorage[this.prefix + key];
      delete localStorage[this.prefix + key + "_expires"];

      return true;
    } catch (err) {
      return false;
    }
  },
};

//env
var _agentHas = function (s) {
  return navigator.userAgent.toLowerCase().indexOf(s) > -1;
};

$.env = {
  isWin: _agentHas("windows"),
  isMac: _agentHas("macintosh"),
  isMobile: _agentHas("android") || _agentHas("iphone"),
  isAndroid: _agentHas("android"),
  isIPhone: _agentHas("iphone"),
  isIE: _agentHas("msie") || _agentHas("trident"),
  isEdge: _agentHas("edge"),
  isFirefox: _agentHas("firefox"),
  isChrome: _agentHas("chrome") && !_agentHas("edge"),
  isSafari: _agentHas("safari") && !_agentHas("chrome"),
  isWeixin: _agentHas("micromessenger"),
  isTouch: "ontouchstart" in window,
  hasMouse:
    !("ontouchstart" in window) || (_agentHas("touch") && _agentHas("msie")),
};

for (var i in $.env) {
  if ($.env[i]) {
    var prop = i.replace(/^(?:is|has)/, "").toLowerCase();
    $("html").addClass("env-" + prop);
  }
}

/** Event Emitter **/
//很容易出现意外的被调用两次的情况
$.Emitter = function () {
  if (!this.hasOwnProperty("_events")) {
    this._events = {};
  }
};

$.Emitter.prototype = {
  on: function (name, handler, scope) {
    if (!handler) {
      console.warn('The "handler" must be specified!');
    }

    var events = this._events[name] || (this._events[name] = []);

    events.push({
      handler: handler,
      scope: scope || null,
    });

    return this;
  },

  once: function (name, handler, scope) {
    if (!handler) {
      console.warn('The "handler" must be specified!');
    }

    var events = this._events[name] || (this._events[name] = []);

    events.push({
      handler: handler,
      scope: scope || null,
      once: true,
    });

    return this;
  },

  //if scope is omit, unbind all the handler, no matter what the scope is
  //if handler is omit, unbind all the handler with this name
  off: function (name, handler, scope) {
    var events = this._events[name];

    if (events) {
      for (var i = events.length - 1; i >= 0; i--) {
        var event = events[i];

        if (
          (!handler || event.handler === handler) &&
          (!scope || event.scope === scope)
        ) {
          events.splice(i, 1);
        }
      }
    }

    return this;
  },

  //processing like off
  hasListener: function (name, handler, scope) {
    var events = this._events[name];

    if (!handler) {
      return events && events.length > 0;
    } else if (events && handler) {
      for (var i = 0, len = events.length; i < len; i++) {
        var event = events[i];

        if (event.handler === handler && (!scope || event.scope === scope)) {
          return true;
        }
      }
    }

    return false;
  },

  trigger: function (name) {
    var events = this._events[name],
      value;

    if (events) {
      var args = Array.from(arguments).slice(1);

      for (var i = 0; i < events.length; i++) {
        var event = events[i];

        //the handler may call off, so must remove it before handle
        if (event.once === true) {
          events.splice(i--, 1);
        }

        event.handler.apply(event.scope, args);
      }
    }
  },
};

$.req = function (url, options = {}) {
  return new Promise((resolve) => {
    //handle xhr
    let xhr = new XMLHttpRequest();
    let getHeader = xhr.getResponseHeader.bind(xhr);

    if (options.withCredentials) {
      try {
        xhr.withCredentials = true;
      } catch (error) {
        console.log(error);
      }
    }

    if (options.onuploadprogress) {
      xhr.upload.addEventListener(
        "progress",
        (e) => {
          if (e.lengthComputable) {
            $.digestAwait(options.onuploadprogress(e));
          }
        },
        false
      );
    }

    if (options.onprogress) {
      xhr.addEventListener(
        "progress",
        (e) => {
          if (e.lengthComputable) {
            $.digestAwait(options.onprogress(e));
          }
        },
        false
      );
    }

    if (options.headers) {
      options.beforeSend = (xhr) => {
        for (let name in options.headers) {
          xhr.setRequestHeader(name, options.headers[name]);
        }
      };
    }

    if (options.xhr) {
      options.xhr = options.xhr;
    } else {
      options.xhr = () => xhr;
    }

    //handle others
    options.url = url;

    if (options.dataType === undefined) {
      options.dataType = "json";
    }

    if (options.processData === false && typeof options.data === "object") {
      options.data = JSON.stringify(options.data);
      options.processData = false;
      options.contentType = false;
    } else if (
      typeof options.data === "string" ||
      options.data instanceof FormData
    ) {
      options.processData = false;
      options.contentType = false;
    }

    options.success = (data, status) => {
      resolve({ ok: true, data, status, getHeader });
      $.defer($.digest); //when using await $.req, code after it will be called after two Micro Tasks sequence
    };

    options.error = (data) => {
      resolve({
        ok: false,
        data: data.responseJSON,
        status: data.status,
        getHeader,
      });
      $.defer($.digest);
    };

    if (options.getAbort) {
      options.getAbort(() => {
        xhr.abort();
      });
    }

    $.ajax(options);
  });
};

$.req.extendMethods = function (req) {
  for (let method of ["HEAD", "GET", "POST", "PUT", "DELETE"]) {
    if (["POST", "PUT"].includes(method)) {
      req[method.toLowerCase()] = function (url, post, options = {}) {
        options.method = method;
        options.data = post;
        return req(url, options);
      };
    } else {
      req[method.toLowerCase()] = function (url, options = {}) {
        options.method = method;
        return req(url, options);
      };
    }
  }
};

$.req.extendMethods($.req);

//a little like lamda expression
$.req.overwrite = function (reqFn, resFn) {
  let req = async function (...args) {
    let { url, options } = reqFn(...args);
    let returns = await $.req(url, options);

    if (resFn) {
      returns = await resFn(returns, ...args);
    }

    return returns;
  };

  $.req.extendMethods(req);

  return req;
};

//compatible with jquery 1.7
$.fn.live = function (types, data, fn) {
  $(this.context).on(types, this.selector, data, fn);
  return this;
};

$.fn.die = function (types, fn) {
  $(this.context).off(types, this.selector || "**", fn);
  return this;
};

/** COMPATIBLE WITH OLD APIS **/
defineValue(String.prototype, "padLeft", String.prototype.padStart);
defineValue(String.prototype, "padRight", String.prototype.padEnd);

$.fn.$on = $.fn.on;
$.fn.$once = $.fn.once;
$.fn.$off = $.fn.off;

$.fn.$trigger = function (eventName) {
  var args = Array.from(arguments).slice(1);

  this.each(function (index, el) {
    if (!el._events) {
      return;
    }

    var events = el._events[eventName];

    if (events) {
      for (var i = 0; i < events.length; i++) {
        var event = events[i];
        event.bindedHandler.apply(null, args);

        if (event.once) {
          i--;
        }
      }
    }
  });

  return this;
};

$.fn.onAllImageLoaded = function (callback, scope) {
  var imgs = this.find("img");
  var total = imgs.length;
  var loaded = 0;

  var onOneImgLoaded = function () {
    loaded++;

    if (loaded === total) {
      onAllLoaded();
    }
  };

  var onAllLoaded = function () {
    callback.call(scope);
  };

  if (loaded === total) {
    onAllLoaded();
  } else {
    imgs.each(function (index, img) {
      if (img.complete) {
        onOneImgLoaded();
      } else {
        $(img).once("load", onOneImgLoaded);
      }
    });
  }
};

//get max height and then set each one
//must at least one is visible
$.fn.syncTextHeights = function () {
  var maxTextCountEl = null;
  var maxTextCount = 0;
  var maxHeight = 0;

  this.css("height", "");

  this.each(function (index, el) {
    var $el = $(el);
    var textCount = $el.text().length;

    if (textCount > maxTextCount) {
      maxTextCount = textCount;
      maxTextCountEl = $el;
    }
  });

  if (!maxTextCountEl.is(":visible")) {
    var visibleEl = this.filter(":visible").eq(0);
    if (!visibleEl.length) {
      return false;
    }

    var clonedMaxTextCountEl = maxTextCountEl.clone();
    visibleEl.after(clonedMaxTextCountEl.show());
    maxHeight = clonedMaxTextCountEl[0].offsetHeight;
    clonedMaxTextCountEl.remove();
  } else {
    maxHeight = maxTextCountEl[0].offsetHeight;
  }

  if (maxHeight > 0) {
    this.css("height", maxHeight);
    return true;
  } else {
    return false;
  }
};

//like before one
$.fn.syncColWidths = function () {
  var colEls = this;
  var maxWidth = 0;
  var widths = [];

  this.css("width", "");

  for (var i = 0; i < this.length; i++) {
    var el = this[i];
    widths[i] = el.offsetWidth;
  }

  maxWidth = Math.max.apply(null, widths);

  if (maxWidth > 0) {
    this.css("width", maxWidth);
    return true;
  } else {
    return false;
  }
};

$.fn.stopableDelay = function (duration, callback) {
  return this.animate({ color: "inherit" }, duration, callback);
};

//trigger fns when window width across threshold value
(function () {
  var mobileHandlers = [];
  var mobileHandlersBinded = false;
  var lastWidth = window.innerWidth;

  function flushMobileHandlers(a) {
    var lastWidth = lastWidth;
    var newWidth = window.innerWidth;

    for (var i = mobileHandlers.length - 1; i >= 0; i--) {
      var a = mobileHandlers[i];
      if (a.on && a.width < lastWidth && a.width >= newWidth) {
        //become narrower
        a.on.call(a.scope);
      } else if (a.un && a.width >= lastWidth && a.width < newWidth) {
        //become wider
        a.un.call(a.scope);
      }
    }

    lastWidth = newWidth;
  }

  function bindMobileHandlers() {
    $(window).on("resize", $.throttle(flushMobileHandlers, 500));
    mobileHandlersBinded = true;
  }

  function unbindMobileHandlers() {
    $(window).off("resize", flushMobileHandlers);
    mobileHandlersBinded = false;
  }

  //you need to know it trigger "on" fn when becomes narrower
  $.onToggleWidth = function (width, on, un, scope) {
    mobileHandlers.push({
      on: on,
      un: un,
      scope: scope,
      width: width,
    });

    if (lastWidth <= width && on) {
      on.call(scope);
    }

    if (!mobileHandlersBinded) {
      bindMobileHandlers();
    }
  };

  $.unToggleWidth = function (on, un, scope) {
    for (var i = mobileHandlers.length - 1; i >= 0; i--) {
      var a = mobileHandlers[i];
      if (
        ((on && a.on === on) || (un && a.un === un)) &&
        (!scope || scope === a.scope)
      ) {
        mobileHandlers.splice(i, 1);
        break;
      }
    }

    if (mobileHandlers.length === 0) {
      unbindMobileHandlers();
    }
  };

  $.onToggleMobile = function (on, un, scope) {
    return $.onToggleWidth(768, on, un, scope);
  };
})();

//add "nocache=1" for amazon cdn server
$.nocache = function (url) {
  if (url.includes("?")) {
    url += "&nocache=1";
  } else {
    url += "?nocache=1";
  }

  return url;
};

//no cache if page has "nocache=1"
$.ifcache = function (url) {
  if (
    location.href.includes("nocache=1") ||
    location.hostname.endsWith(".dev")
  ) {
    if (url.includes("?")) {
      url += "&nocache=1";
    } else {
      url += "?nocache=1";
    }
  }

  return url;
};

//after all the js codes ran
$.onDomCompleted = function (fn, scope) {
  if (document.readyState === "complete") {
    fn.call(scope);
  } else {
    var handler = function () {
      if (document.readyState === "complete") {
        $(document).off("readystatechange", handler);
        fn.call(scope);
      }
    };

    $(document).on("readystatechange", handler);
  }
};

$.fn.findOrSelf = function (selector) {
  return this.find(selector).add(this.filter(selector));
};

//rename $.xxx
$.onDomReady = $.onReady;
$.onWinLoaded = $.onWindowLoaded;
$.getTimeString = $.formatDate;
$.htmlEncode = $.encodeHTML;
$.parseParams = $.parseQuery;
$.useParams = $.useQuery;
$.blockFn = $.lazyThrottle;

export default $